var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "105 15 105 35 85 35"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "35 85 15 85 15 105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.04435,30.054245 C90.9248191,17.87893 76.3825209,10 60,10 C32.3857625,10 10,32.3857625 10,60 M20.2451267,90.3284041 C29.3812154,102.285896 43.7897449,110 60,110 C87.6142375,110 110,87.6142375 110,60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.ced797bc6eb0bb3466415d2de7585f2f.svg";
export { ForwardRef as ReactComponent };